const messages: Record<string, string> = {
  MARKER_LIMIT: "這塊領地的標記已滿（50）",
  MARKER_NOT_FOUND: "標記已被刪除",
  MARKER_CHANGED: "標記在你讀取後被修改了，請重新開啟",
  AGENT_NOT_FOUND: "這個 agent 已撤銷",
  MAIL_NOT_FOUND: "找不到這封信",
  MAIL_FULL: "agent 的未讀來信已滿（50）",
  CHAT_INVALID: "訊息不能有換行或控制字元",
  CHAT_IN_ROOM: "房間裡沒有附近的人",
  CHAT_TOO_LONG: "訊息最多 500 字",
  CHAT_RATE_LIMITED: "說太快了，稍等一下",
  CHAT_FORBIDDEN: "你不在這塊領地",
  CHANNEL_NOT_FOUND: "這個頻道不存在",
  CHAT_MESSAGE_NOT_FOUND: "找不到這則訊息（可能已被刪除）",
  UNAUTHORIZED: "請先登入",
  INVALID_CODE: "驗證碼錯誤或已失效，請重新取得",
  RATE_LIMITED: "嘗試太頻繁，請稍後再試",
  ALREADY_REGISTERED: "這個 email 已經註冊了",
  INVITE_ACCEPTED: "這個邀請已被使用",
  INVITE_NOT_FOUND: "找不到這個邀請",
  ACCOUNT_NOT_FOUND: "找不到這個帳號",
  CANNOT_DISABLE_ADMIN: "管理員帳號不能停用",
  AGENT_FORBIDDEN: "agent 不能使用這個功能",
  AGENT_LIMIT: "agent 已達上限（20 個），請先撤銷不用的 agent",
  INVALID_PAIR_CODE: "配對碼錯誤、已過期或已使用",
  UPLOAD_EXPIRED: "上傳網址已過期或已使用",
  OAUTH_REQUEST_EXPIRED: "授權請求已過期，請回到 client 重新連線",
  VALIDATION: "輸入格式不正確",
  ASSET_TOO_LARGE: "檔案超過大小上限",
  ASSET_NOT_GLB: "不是 GLB 檔案",
  ASSET_INVALID: "無法解析這個 GLB",
  ASSET_EXTERNAL_URI: "GLB 不能引用外部檔案",
  ASSET_TOO_MANY_TRIANGLES: "三角形數量超過上限",
  ASSET_TEXTURE_TOO_LARGE: "貼圖邊長超過上限",
  ASSET_TOO_MANY_TEXTURES: "貼圖數量超過上限",
  ASSET_TOO_MANY_NODES: "節點數量超過上限",
  ASSET_NOT_FOUND: "找不到這個資產",
  NOT_OWNER: "你不是這個資產的擁有者",
  RECIPIENT_NOT_FOUND: "找不到收件者",
  LEDGER_CONFLICT: "同時有另一筆轉讓，請重試",
  PLOT_FULL: "展示區已滿",
  PLOT_QUOTA: "你在這個展示區的配額已用完",
  OUT_OF_PLOT: "位置不在展示區內",
  PLOT_NOT_FOUND: "找不到展示區",
  ENTITY_NOT_FOUND: "這個物件已不存在",
  ASSET_NOT_LICENSED: "這個資產的政策不允許你擺放",
  FORBIDDEN: "你沒有權限這樣做",
  PARCEL_NOT_FOUND: "找不到這塊地",
  PARCEL_TAKEN: "這塊地已經有人了",
  PLOT_LIMIT: "你已經有一塊領地了",
  LAYOUT_INVALID: "版面有錯誤，請看細節",
  LAYOUT_CONFLICT: "領地在你讀取後有變動，請重新整理後再試",
  PLOT_CROSSES_ZONE: "領地不能跨分區",
  UNSUPPORTED: "這個功能尚未開放",
  INTERNAL: "伺服器發生錯誤，請稍後再試",
};

export function describeError(code: string, fallback = "發生錯誤"): string {
  return messages[code] ?? fallback;
}
